import React from 'react';
import SectionWrapper from '../UI/SectionWrapper';
import { Home, Zap, Heart, Shield, Activity, Wifi, Compass, Anchor, Moon, PawPrint } from 'lucide-react';

const gridItems = [
  { id: 1, title: 'Health Problems', icon: Heart, desc: "Help understand and resolve the effect that underground water, negative ley lines and EMF could be having on your body.", className: "md:col-span-2 bg-rose-100/50" },
  { id: 2, title: 'Selling/Buying', icon: Home, desc: "Clearing stagnant energy for a smooth sale, or checking a new home.", className: "md:row-span-2 bg-emerald-100/50" },
  { id: 3, title: 'Project Delays', icon: Compass, desc: "Helping developers achieve success.", className: "bg-orange-100/50" },
  { id: 4, title: 'Business Challenges', icon: Anchor, desc: "Shifting issues with staff and flow.", className: "md:col-span-1 bg-sky-100/50" },
  { id: 5, title: 'Environmental Disturbance', icon: Activity, desc: "Healing land affected by floods, fire, construction, or tree loss.", className: "md:col-span-2 bg-stone-100/60" },
  { id: 6, title: 'Sense of Unease', icon: Moon, desc: "Lifting heaviness and shifting the feeling of 'something doesn't feel right'.", className: "md:row-span-2 bg-indigo-100/50" },
  { id: 7, title: 'Sleep Problems', icon: Moon, desc: "Creating a restful sanctuary.", className: "bg-blue-100/50" },
  { id: 8, title: 'Money Flow', icon: Zap, desc: "Unblocking energy affecting abundance.", className: "bg-amber-100/50" },
  { id: 9, title: 'Relationship Stress', icon: Heart, desc: "Harmonizing space to reduce tension.", className: "md:row-span-2 bg-purple-100/50" },
  { id: 10, title: 'Neighbour Disputes', icon: Shield, desc: "Shifting conflict with neighbours.", className: "md:col-span-2 bg-red-100/50" },
  { id: 11, title: 'Real Estate Challenges', icon: Home, desc: "Assisting with seeking, selling, and leasing properties.", className: "bg-teal-100/50" },
  { id: 12, title: 'EMF Radiation', icon: Wifi, desc: "Harmonizing fields from technology.", className: "bg-violet-100/50" },
  { id: 13, title: 'Traumatic Events', icon: Activity, desc: "Clearing energy after illness, death, arguments, or accidents.", className: "md:col-span-2 bg-fuchsia-100/50" },
  { id: 14, title: 'Conflict', icon: Shield, desc: "Resolving family or work conflicts.", className: "md:col-span-2 bg-pink-100/50" },
  { id: 15, title: 'Animals', icon: PawPrint, desc: "Pet and livestock wellbeing", className: "md:col-span-2 bg-lime-100/50" },
];

const HealingGrid = () => {
  return (
    <SectionWrapper id="healing" className="text-center max-w-7xl mx-auto py-20 bg-stone-50/30">
      <h2 className="text-4xl md:text-5xl font-serif text-forest-green mb-12">
        What Land Healing <span className="italic">Helps With</span>
      </h2>
      
      <div className="container mx-auto px-4">
        {/* Varied "Organic" Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 auto-rows-[minmax(160px,auto)] grid-flow-dense">
          {gridItems.map((item) => (
            <div 
              key={item.id}
              className={`
                ${item.className || 'bg-white'} 
                backdrop-blur-sm rounded-2xl p-6 
                border border-forest-green/5 shadow-sm hover:shadow-md hover:-translate-y-1
                transition-all duration-300 flex flex-col items-center justify-center text-center group
              `}
            >
              <div className="w-10 h-10 rounded-full bg-white/70 flex items-center justify-center mb-3 shadow-sm group-hover:scale-110 transition-transform duration-300">
                <item.icon className="w-5 h-5 text-forest-green stroke-[1.5]" />
              </div>
              
              <h3 className="text-base font-serif font-medium text-forest-green mb-2">{item.title}</h3>
              <p className="text-sm text-gray-700 font-sans leading-relaxed px-1">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default HealingGrid;
